// 힐스테이트 성남메트로블 키오스크(event7) 주소 선택 데이터: 시/도 → 시/군/구 → 읍·면·동
// - 시/도·시/군/구 구성: work/26.10.13/지역선택 데이터_작업용.xlsx
// - 읍·면·동: 행정안전부 주민등록 인구통계(jumin.mois.go.kr) 행정동 기준 2026.09
// - 2026.07 행정구역 개편 반영: 인천 중구·동구·서구 → 제물포구·영종구·서해구·검단구, 화성시 4개 구 신설
//   (광주광역시·전라남도는 엑셀 구성대로 표시, 동 목록은 전남광주통합특별시 자료 사용)
// - 빈 배열(기타)은 동 단계 없이 바로 선택 완료
export default {
	강원특별자치도: {
		강릉시: [
			'주문진읍',
			'성산면',
			'왕산면',
			'구정면',
			'강동면',
			'옥계면',
			'사천면',
			'연곡면',
			'홍제동',
			'중앙동',
			'옥천동',
			'교1동',
			'교2동',
			'포남1동',
			'포남2동',
			'초당동',
			'송정동',
			'내곡동',
			'강남동',
			'성덕동',
			'경포동',
		],
		고성군: ['간성읍', '거진읍', '현내면', '죽왕면', '토성면', '수동면'],
		동해시: ['천곡동', '송정동', '북삼동', '부곡동', '동호동', '발한동', '묵호동', '북평동', '망상동', '삼화동'],
		삼척시: [
			'도계읍',
			'원덕읍',
			'원덕읍임원출장소',
			'근덕면',
			'하장면',
			'노곡면',
			'미로면',
			'가곡면',
			'신기면',
			'남양동',
			'교동',
			'정라동',
			'성내동',
		],
		속초시: ['영랑동', '동명동', '금호동', '교동', '노학동', '조양동', '청호동', '대포동'],
		양구군: ['양구읍', '국토정중앙면', '동면', '방산면', '해안면'],
		양양군: ['양양읍', '서면', '손양면', '현북면', '현남면', '강현면'],
		영월군: ['영월읍', '상동읍', '산솔면', '김삿갓면', '북면', '남면', '한반도면', '한반도면쌍용출장소', '주천면', '무릉도원면'],
		원주시: [
			'문막읍',
			'소초면',
			'호저면',
			'지정면',
			'부론면',
			'귀래면',
			'흥업면',
			'판부면',
			'신림면',
			'중앙동',
			'원인동',
			'개운동',
			'명륜1동',
			'명륜2동',
			'단구동',
			'일산동',
			'학성동',
			'단계동',
			'우산동',
			'태장1동',
			'태장2동',
			'봉산동',
			'행구동',
			'무실동',
			'반곡관설동',
		],
		인제군: ['인제읍', '인제읍귀둔출장소', '남면', '북면', '기린면', '서화면', '상남면'],
		정선군: ['정선읍', '고한읍', '사북읍', '신동읍', '신동읍함백출장소', '남면', '북평면', '임계면', '화암면', '여량면'],
		철원군: ['철원읍', '김화읍', '갈말읍', '동송읍', '서면', '서면와수출장소', '근남면', '근북면', '근동면', '원동면', '원남면', '임남면'],
		춘천시: [
			'신북읍',
			'동면',
			'동산면',
			'신동면',
			'남면',
			'서면',
			'사북면',
			'북산면',
			'동내면',
			'남산면',
			'교동',
			'조운동',
			'약사명동',
			'근화동',
			'소양동',
			'후평1동',
			'후평2동',
			'후평3동',
			'효자1동',
			'효자2동',
			'효자3동',
			'석사동',
			'퇴계동',
			'강남동',
			'신사우동',
		],
		태백시: ['황지동', '황연동', '삼수동', '상장동', '문곡소도동', '장성동', '구문소동', '철암동'],
		평창군: ['평창읍', '미탄면', '방림면', '방림면계촌출장소', '대화면', '봉평면', '용평면', '진부면', '대관령면'],
		홍천군: ['홍천읍', '화촌면', '두촌면', '내촌면', '서석면', '영귀미면', '남면', '서면', '북방면', '내면'],
		화천군: ['화천읍', '간동면', '하남면', '상서면', '사내면'],
		횡성군: ['횡성읍', '우천면', '안흥면', '둔내면', '갑천면', '청일면', '공근면', '서원면', '강림면'],
		기타: [],
	},
	경기도: {
		가평군: ['가평읍', '설악면', '청평면', '상면', '조종면', '북면'],
		'고양시 덕양구': [
			'주교동',
			'원신동',
			'흥도동',
			'성사1동',
			'성사2동',
			'효자동',
			'삼송1동',
			'삼송2동',
			'창릉동',
			'고양동',
			'관산동',
			'능곡동',
			'화정1동',
			'화정2동',
			'행주동',
			'행신1동',
			'행신2동',
			'행신3동',
			'행신4동',
			'화전동',
			'대덕동',
		],
		'고양시 일산동구': [
			'식사동',
			'중산1동',
			'중산2동',
			'정발산동',
			'풍산동',
			'백석1동',
			'백석2동',
			'마두1동',
			'마두2동',
			'장항1동',
			'장항2동',
			'고봉동',
		],
		'고양시 일산서구': [
			'일산1동',
			'일산2동',
			'일산3동',
			'탄현1동',
			'탄현2동',
			'주엽1동',
			'주엽2동',
			'대화동',
			'송포동',
			'덕이동',
			'가좌동',
		],
		과천시: ['중앙동', '원문동', '갈현동', '별양동', '부림동', '과천동', '문원동'],
		광명시: [
			'광명1동',
			'광명2동',
			'광명3동',
			'광명4동',
			'광명5동',
			'광명6동',
			'광명7동',
			'철산1동',
			'철산2동',
			'철산3동',
			'철산4동',
			'하안1동',
			'하안2동',
			'하안3동',
			'하안4동',
			'소하1동',
			'소하2동',
			'일직동',
			'학온동',
		],
		광주시: [
			'초월읍',
			'곤지암읍',
			'도척면',
			'퇴촌면',
			'남종면',
			'남한산성면',
			'경안동',
			'송정동',
			'쌍령동',
			'탄벌동',
			'광남1동',
			'광남2동',
			'오포1동',
			'오포2동',
			'신현동',
			'능평동',
		],
		구리시: ['갈매동', '동구동', '인창동', '교문1동', '교문2동', '수택1동', '수택2동', '수택3동'],
		군포시: ['군포1동', '군포2동', '산본1동', '산본2동', '금정동', '재궁동', '오금동', '수리동', '궁내동', '대야동', '광정동', '송부동'],
		김포시: [
			'통진읍',
			'고촌읍',
			'양촌읍',
			'대곶면',
			'월곶면',
			'하성면',
			'김포본동',
			'장기본동',
			'사우동',
			'풍무동',
			'장기동',
			'구래동',
			'마산동',
			'운양동',
		],
		남양주시: [
			'와부읍',
			'진접읍',
			'화도읍',
			'화도읍동부출장소',
			'화도읍남부출장소',
			'진건읍',
			'오남읍',
			'퇴계원읍',
			'별내면',
			'수동면',
			'조안면',
			'호평동',
			'평내동',
			'금곡동',
			'양정동',
			'다산1동',
			'다산2동',
			'별내동',
		],
		동두천시: ['생연1동', '생연2동', '중앙동', '보산동', '불현동', '송내동', '소요동', '상패동'],
		'부천시 소사구': ['심곡본1동', '심곡본동', '소사본동', '소사본1동', '범박동', '옥길동', '괴안동', '역곡3동', '송내1동', '송내2동'],
		'부천시 오정구': ['성곡동', '원종1동', '원종2동', '고강본동', '고강1동', '오정동', '신흥동'],
		'부천시 원미구': [
			'심곡1동',
			'심곡2동',
			'심곡3동',
			'원미1동',
			'원미2동',
			'소사동',
			'역곡1동',
			'역곡2동',
			'춘의동',
			'도당동',
			'약대동',
			'중동',
			'중1동',
			'중2동',
			'중3동',
			'중4동',
			'상동',
			'상1동',
			'상2동',
			'상3동',
		],
		'성남시 분당구': [
			'분당동',
			'수내1동',
			'수내2동',
			'수내3동',
			'정자동',
			'정자1동',
			'정자2동',
			'정자3동',
			'서현1동',
			'서현2동',
			'이매1동',
			'이매2동',
			'야탑1동',
			'야탑2동',
			'야탑3동',
			'판교동',
			'삼평동',
			'백현동',
			'금곡동',
			'구미1동',
			'구미동',
			'운중동',
		],
		'성남시 수정구': [
			'신흥1동',
			'신흥2동',
			'신흥3동',
			'태평1동',
			'태평2동',
			'태평3동',
			'태평4동',
			'수진1동',
			'수진2동',
			'단대동',
			'산성동',
			'양지동',
			'복정동',
			'위례동',
			'신촌동',
			'고등동',
			'시흥동',
		],
		'성남시 중원구': [
			'성남동',
			'중앙동',
			'금광1동',
			'금광2동',
			'은행1동',
			'은행2동',
			'상대원1동',
			'상대원2동',
			'상대원3동',
			'하대원동',
			'도촌동',
		],
		'수원시 권선구': [
			'세류1동',
			'세류2동',
			'세류3동',
			'평동',
			'서둔동',
			'구운동',
			'금곡동',
			'호매실동',
			'권선1동',
			'권선2동',
			'곡선동',
			'입북동',
		],
		'수원시 영통구': [
			'매탄1동',
			'매탄2동',
			'매탄3동',
			'매탄4동',
			'원천동',
			'영통1동',
			'영통2동',
			'영통3동',
			'망포1동',
			'망포2동',
			'광교1동',
			'광교2동',
		],
		'수원시 장안구': ['파장동', '율천동', '정자1동', '정자2동', '정자3동', '영화동', '송죽동', '조원1동', '조원2동', '연무동'],
		'수원시 팔달구': ['매교동', '매산동', '고등동', '화서1동', '화서2동', '지동', '우만1동', '우만2동', '인계동', '행궁동'],
		시흥시: [
			'대야동',
			'신천동',
			'신현동',
			'은행동',
			'매화동',
			'목감동',
			'군자동',
			'월곶동',
			'정왕본동',
			'정왕1동',
			'정왕2동',
			'정왕3동',
			'정왕4동',
			'배곧1동',
			'배곧2동',
			'과림동',
			'연성동',
			'장곡동',
			'능곡동',
			'거북섬동',
		],
		'안산시 단원구': [
			'와동',
			'고잔동',
			'중앙동',
			'호수동',
			'원곡동',
			'백운동',
			'신길동',
			'초지동',
			'선부1동',
			'선부2동',
			'선부3동',
			'대부동',
		],
		'안산시 상록구': [
			'일동',
			'이동',
			'사동',
			'사이동',
			'해양동',
			'본오1동',
			'본오2동',
			'본오3동',
			'부곡동',
			'월피동',
			'성포동',
			'반월동',
			'안산동',
		],
		안성시: [
			'공도읍',
			'보개면',
			'금광면',
			'서운면',
			'미양면',
			'대덕면',
			'양성면',
			'원곡면',
			'일죽면',
			'죽산면',
			'삼죽면',
			'고삼면',
			'안성1동',
			'안성2동',
			'안성3동',
		],
		'안양시 동안구': [
			'비산1동',
			'비산2동',
			'비산3동',
			'부흥동',
			'달안동',
			'관양동',
			'인덕원동',
			'부림동',
			'평촌동',
			'평안동',
			'귀인동',
			'호계1동',
			'호계2동',
			'호계3동',
			'범계동',
			'신촌동',
			'갈산동',
		],
		'안양시 만안구': [
			'안양1동',
			'안양2동',
			'안양3동',
			'안양4동',
			'안양5동',
			'안양6동',
			'안양7동',
			'명학동',
			'병목안동',
			'석수1동',
			'석수2동',
			'충훈동',
			'박달동',
			'호현동',
		],
		양주시: ['백석읍', '은현면', '남면', '광적면', '장흥면', '양주1동', '양주2동', '회천1동', '회천2동', '회천3동', '옥정1동', '옥정2동'],
		양평군: ['양평읍', '강상면', '강하면', '양서면', '옥천면', '서종면', '단월면', '청운면', '양동면', '지평면', '용문면', '개군면'],
		여주시: ['가남읍', '점동면', '흥천면', '금사면', '세종대왕면', '대신면', '북내면', '강천면', '산북면', '여흥동', '중앙동', '오학동'],
		연천군: ['연천읍', '전곡읍', '군남면', '청산면', '백학면', '미산면', '왕징면', '신서면', '중면', '장남면'],
		오산시: ['중앙동', '대원1동', '대원2동', '남촌동', '신장1동', '신장2동', '세마동', '초평동'],
		'용인시 기흥구': [
			'신갈동',
			'영덕1동',
			'영덕2동',
			'구갈동',
			'상갈동',
			'보라동',
			'기흥동',
			'서농동',
			'구성동',
			'마북동',
			'동백1동',
			'동백2동',
			'동백3동',
			'상하동',
			'보정동',
		],
		'용인시 수지구': [
			'풍덕천1동',
			'풍덕천2동',
			'신봉동',
			'죽전1동',
			'죽전2동',
			'죽전3동',
			'동천동',
			'상현1동',
			'상현2동',
			'상현3동',
			'성복동',
		],
		'용인시 처인구': [
			'포곡읍',
			'모현읍',
			'이동읍',
			'남사읍',
			'양지읍',
			'원삼면',
			'백암면',
			'중앙동',
			'역북동',
			'삼가동',
			'유림1동',
			'유림2동',
			'동부동',
		],
		의왕시: ['고천동', '부곡동', '오전동', '내손1동', '내손2동', '청계동'],
		의정부시: [
			'의정부1동',
			'의정부2동',
			'호원1동',
			'호원2동',
			'장암동',
			'신곡1동',
			'신곡2동',
			'송산1동',
			'송산2동',
			'송산3동',
			'자금동',
			'가능동',
			'흥선동',
			'녹양동',
			'고산동',
		],
		이천시: [
			'장호원읍',
			'부발읍',
			'신둔면',
			'백사면',
			'호법면',
			'마장면',
			'대월면',
			'모가면',
			'설성면',
			'율면',
			'창전동',
			'증포동',
			'중리동',
			'관고동',
		],
		파주시: [
			'문산읍',
			'파주읍',
			'법원읍',
			'조리읍',
			'월롱면',
			'탄현면',
			'광탄면',
			'파평면',
			'적성면',
			'장단면',
			'금촌1동',
			'금촌2동',
			'금촌3동',
			'교하동',
			'운정1동',
			'운정2동',
			'운정3동',
			'운정4동',
			'운정5동',
			'운정6동',
		],
		평택시: [
			'팽성읍',
			'안중읍',
			'포승읍',
			'청북읍',
			'진위면',
			'서탄면',
			'고덕면',
			'오성면',
			'현덕면',
			'중앙동',
			'서정동',
			'송탄동',
			'지산동',
			'송북동',
			'신장1동',
			'신장2동',
			'신평동',
			'원평동',
			'통복동',
			'비전1동',
			'비전2동',
			'용이동',
			'세교동',
			'동삭동',
			'고덕동',
		],
		포천시: [
			'소흘읍',
			'군내면',
			'내촌면',
			'가산면',
			'신북면',
			'창수면',
			'영중면',
			'일동면',
			'이동면',
			'영북면',
			'관인면',
			'화현면',
			'포천동',
			'선단동',
		],
		하남시: [
			'천현동',
			'신장1동',
			'신장2동',
			'덕풍1동',
			'덕풍2동',
			'덕풍3동',
			'감북동',
			'감일동',
			'위례동',
			'춘궁동',
			'초이동',
			'미사1동',
			'미사2동',
			'미사3동',
		],
		'화성시 동탄구': ['동탄1동', '동탄2동', '동탄3동', '동탄4동', '동탄5동', '동탄6동', '동탄7동', '동탄8동', '동탄9동'],
		'화성시 만세구': ['우정읍', '향남읍', '남양읍', '마도면', '송산면', '서신면', '팔탄면', '장안면', '양감면', '새솔동'],
		'화성시 병점구': ['진안동', '병점1동', '병점2동', '반월동', '화산동'],
		'화성시 효행구': ['봉담읍', '매송면', '비봉면', '정남면', '기배동'],
		기타: [],
	},
	경상남도: {
		거제시: [
			'일운면',
			'동부면',
			'남부면',
			'거제면',
			'둔덕면',
			'사등면',
			'사등면가조출장소',
			'연초면',
			'하청면',
			'하청면칠천출장소',
			'장목면',
			'장목면외포출장소',
			'장승포동',
			'능포동',
			'아주동',
			'옥포1동',
			'옥포2동',
			'장평동',
			'고현동',
			'상문동',
			'수양동',
		],
		거창군: ['거창읍', '주상면', '웅양면', '고제면', '북상면', '위천면', '마리면', '남상면', '남하면', '신원면', '가조면', '가북면'],
		고성군: [
			'고성읍',
			'삼산면',
			'하일면',
			'하이면',
			'상리면',
			'대가면',
			'영현면',
			'영오면',
			'개천면',
			'구만면',
			'회화면',
			'마암면',
			'동해면',
			'거류면',
		],
		김해시: [
			'진영읍',
			'주촌면',
			'진례면',
			'한림면',
			'생림면',
			'상동면',
			'대동면',
			'동상동',
			'회현동',
			'부원동',
			'내외동',
			'북부동',
			'칠산서부동',
			'활천동',
			'삼안동',
			'불암동',
			'장유1동',
			'장유2동',
			'장유3동',
		],
		남해군: ['남해읍', '이동면', '상주면', '삼동면', '미조면', '남면', '서면', '고현면', '설천면', '창선면'],
		밀양시: [
			'삼랑진읍',
			'삼랑진임천출장소',
			'하남읍',
			'부북면',
			'상동면',
			'산외면',
			'산내면',
			'단장면',
			'상남면',
			'초동면',
			'무안면',
			'청도면',
			'내일동',
			'내이동',
			'삼문동',
			'가곡동',
			'교동',
		],
		사천시: [
			'사천읍',
			'정동면',
			'사남면',
			'용현면',
			'축동면',
			'곤양면',
			'곤명면',
			'서포면',
			'동서동',
			'선구동',
			'동서금동',
			'벌용동',
			'향촌동',
			'남양동',
			'신수출장소',
		],
		산청군: ['산청읍', '차황면', '오부면', '생초면', '금서면', '삼장면', '시천면', '단성면', '신안면', '생비량면', '신등면'],
		양산시: [
			'물금읍',
			'동면',
			'원동면',
			'상북면',
			'하북면',
			'중앙동',
			'양주동',
			'삼성동',
			'강서동',
			'서창동',
			'소주동',
			'평산동',
			'덕계동',
		],
		의령군: [
			'의령읍',
			'가례면',
			'칠곡면',
			'대의면',
			'화정면',
			'용덕면',
			'정곡면',
			'지정면',
			'낙서면',
			'부림면',
			'봉수면',
			'궁류면',
			'유곡면',
		],
		진주시: [
			'문산읍',
			'내동면',
			'정촌면',
			'금곡면',
			'진성면',
			'일반성면',
			'이반성면',
			'사봉면',
			'지수면',
			'대곡면',
			'금산면',
			'집현면',
			'미천면',
			'명석면',
			'대평면',
			'수곡면',
			'천전동',
			'성북동',
			'중앙동',
			'상봉동',
			'상대동',
			'하대동',
			'상평동',
			'초장동',
			'평거동',
			'신안동',
			'이현동',
			'판문동',
			'가호동',
			'충무공동',
		],
		창녕군: [
			'창녕읍',
			'남지읍',
			'고암면',
			'성산면',
			'대합면',
			'이방면',
			'유어면',
			'대지면',
			'계성면',
			'영산면',
			'장마면',
			'도천면',
			'길곡면',
			'부곡면',
		],
		'창원시 마산합포구': [
			'구산면',
			'진동면',
			'진북면',
			'진전면',
			'현동',
			'가포동',
			'월영동',
			'문화동',
			'반월중앙동',
			'완월동',
			'자산동',
			'교방동',
			'오동동',
			'합포동',
			'산호동',
		],
		'창원시 마산회원구': [
			'내서읍',
			'회원1동',
			'회원2동',
			'석전동',
			'회성동',
			'양덕1동',
			'양덕2동',
			'합성1동',
			'합성2동',
			'구암1동',
			'구암2동',
			'봉암동',
		],
		'창원시 성산구': ['반송동', '용지동', '중앙동', '상남동', '사파동', '가음정동', '성주동', '웅남동'],
		'창원시 의창구': ['동읍', '북면', '대산면', '의창동', '팔룡동', '명곡동', '봉림동'],
		'창원시 진해구': [
			'충무동',
			'여좌동',
			'태백동',
			'경화동',
			'병암동',
			'석동',
			'이동',
			'자은동',
			'덕산동',
			'풍호동',
			'웅천동',
			'웅동1동',
			'웅동2동',
		],
		통영시: [
			'산양읍',
			'용남면',
			'도산면',
			'광도면',
			'욕지면',
			'한산면',
			'사량면',
			'도천동',
			'명정동',
			'중앙동',
			'정량동',
			'북신동',
			'미수동',
			'봉평동',
			'무전동',
		],
		하동군: [
			'하동읍',
			'화개면',
			'악양면',
			'적량면',
			'횡천면',
			'고전면',
			'금남면',
			'진교면',
			'양보면',
			'북천면',
			'청암면',
			'옥종면',
			'금성면',
		],
		함안군: ['가야읍', '칠원읍', '함안면', '군북면', '법수면', '대산면', '칠서면', '칠북면', '산인면', '여항면'],
		함양군: ['함양읍', '마천면', '휴천면', '유림면', '수동면', '지곡면', '안의면', '서하면', '서상면', '백전면', '병곡면'],
		합천군: [
			'합천읍',
			'봉산면',
			'묘산면',
			'가야면',
			'야로면',
			'율곡면',
			'초계면',
			'쌍책면',
			'덕곡면',
			'청덕면',
			'적중면',
			'대양면',
			'쌍백면',
			'삼가면',
			'가회면',
			'대병면',
			'용주면',
		],
		기타: [],
	},
	경상북도: {
		경산시: [
			'하양읍',
			'진량읍',
			'압량읍',
			'와촌면',
			'자인면',
			'용성면',
			'남산면',
			'남천면',
			'중방동',
			'중앙동',
			'남부동',
			'서부1동',
			'서부2동',
			'북부동',
			'동부동',
		],
		경주시: [
			'감포읍',
			'안강읍',
			'건천읍',
			'외동읍',
			'문무대왕면',
			'양남면',
			'내남면',
			'산내면',
			'서면',
			'현곡면',
			'강동면',
			'천북면',
			'황오동',
			'성건동',
			'황남동',
			'선도동',
			'월성동',
			'용강동',
			'황성동',
			'동천동',
			'불국동',
			'보덕동',
		],
		고령군: ['대가야읍', '덕곡면', '운수면', '성산면', '다산면', '개진면', '우곡면', '쌍림면'],
		구미시: [
			'선산읍',
			'고아읍',
			'산동읍',
			'무을면',
			'옥성면',
			'도개면',
			'해평면',
			'장천면',
			'송정동',
			'원평동',
			'도량동',
			'지산동',
			'선주원남동',
			'형곡1동',
			'형곡2동',
			'신평1동',
			'신평2동',
			'비산동',
			'광평동',
			'상모사곡동',
			'임오동',
			'인동동',
			'진미동',
			'양포동',
			'공단동',
		],
		김천시: [
			'아포읍',
			'농소면',
			'남면',
			'개령면',
			'감문면',
			'어모면',
			'봉산면',
			'대항면',
			'감천면',
			'조마면',
			'구성면',
			'지례면',
			'부항면',
			'대덕면',
			'증산면',
			'자산동',
			'평화남산동',
			'양금동',
			'대신동',
			'대곡동',
			'지좌동',
			'율곡동',
		],
		문경시: [
			'문경읍',
			'문경읍갈평출장소',
			'가은읍',
			'가은읍북부출장소',
			'영순면',
			'산양면',
			'호계면',
			'산북면',
			'동로면',
			'마성면',
			'농암면',
			'점촌1동',
			'점촌2동',
			'점촌3동',
			'점촌4동',
			'점촌5동',
		],
		봉화군: ['봉화읍', '물야면', '봉성면', '법전면', '춘양면', '소천면', '재산면', '명호면', '상운면', '석포면'],
		상주시: [
			'함창읍',
			'중동면',
			'사벌국면',
			'낙동면',
			'낙동면동부출장소',
			'청리면',
			'공성면',
			'외남면',
			'내서면',
			'모동면',
			'모서면',
			'모서면서부출장소',
			'화동면',
			'화서면',
			'화북면',
			'화북면서부출장소',
			'외서면',
			'은척면',
			'은척면북부출장소',
			'공검면',
			'이안면',
			'화남면',
			'남원동',
			'북문동',
			'계림동',
			'동문동',
			'동성동',
			'신흥동',
		],
		성주군: ['성주읍', '선남면', '용암면', '수륜면', '가천면', '금수강산면', '대가면', '벽진면', '초전면', '월항면'],
		안동시: [
			'풍산읍',
			'와룡면',
			'북후면',
			'서후면',
			'풍천면',
			'일직면',
			'남후면',
			'남선면',
			'임하면',
			'길안면',
			'임동면',
			'예안면',
			'도산면',
			'녹전면',
			'중구동',
			'명륜동',
			'용상동',
			'서구동',
			'태화동',
			'평화동',
			'안기동',
			'옥동',
			'송하동',
			'강남동',
		],
		영덕군: [
			'영덕읍',
			'강구면',
			'남정면',
			'달산면',
			'지품면',
			'지품면원전출장소',
			'축산면',
			'축산면축산출장소',
			'영해면',
			'병곡면',
			'창수면',
		],
		영양군: ['영양읍', '입암면', '청기면', '일월면', '수비면', '석보면'],
		영주시: [
			'풍기읍',
			'이산면',
			'평은면',
			'문수면',
			'장수면',
			'안정면',
			'봉현면',
			'순흥면',
			'단산면',
			'부석면',
			'상망동',
			'하망동',
			'영주1동',
			'영주2동',
			'휴천1동',
			'휴천2동',
			'휴천3동',
			'가흥1동',
			'가흥2동',
		],
		영천시: [
			'금호읍',
			'청통면',
			'신녕면',
			'화산면',
			'화북면',
			'화남면',
			'자양면',
			'임고면',
			'고경면',
			'북안면',
			'대창면',
			'동부동',
			'중앙동',
			'서부동',
			'완산동',
			'남부동',
		],
		예천군: ['예천읍', '호명읍', '용문면', '감천면', '보문면', '유천면', '용궁면', '개포면', '지보면', '풍양면', '효자면', '은풍면'],
		울릉군: ['울릉읍', '서면', '서면태하출장소', '북면'],
		울진군: ['울진읍', '평해읍', '북면', '북면하당출장소', '근남면', '기성면', '온정면', '죽변면', '후포면', '금강송면', '매화면'],
		의성군: [
			'의성읍',
			'단촌면',
			'점곡면',
			'옥산면',
			'사곡면',
			'춘산면',
			'가음면',
			'금성면',
			'봉양면',
			'비안면',
			'구천면',
			'단밀면',
			'단북면',
			'안계면',
			'다인면',
			'신평면',
			'안평면',
			'안사면',
		],
		청도군: [
			'화양읍',
			'화양읍남성현출장소',
			'청도읍',
			'청도읍유호출장소',
			'각남면',
			'풍각면',
			'각북면',
			'이서면',
			'운문면',
			'금천면',
			'매전면',
		],
		청송군: ['청송읍', '주왕산면', '부남면', '현동면', '현서면', '안덕면', '파천면', '진보면'],
		칠곡군: ['왜관읍', '북삼읍', '석적읍', '지천면', '동명면', '가산면', '약목면', '기산면'],
		'포항시 남구': [
			'구룡포읍',
			'연일읍',
			'오천읍',
			'대송면',
			'동해면',
			'장기면',
			'호미곶면',
			'상대동',
			'해도동',
			'송도동',
			'청림동',
			'제철동',
			'효곡동',
			'대이동',
		],
		'포항시 북구': [
			'흥해읍',
			'신광면',
			'청하면',
			'송라면',
			'기계면',
			'죽장면',
			'죽장면상옥출장소',
			'기북면',
			'중앙동',
			'양학동',
			'죽도동',
			'용흥동',
			'우창동',
			'두호동',
			'장량동',
			'환여동',
		],
		기타: [],
	},
	광주광역시: {
		광산구: [
			'송정1동',
			'송정2동',
			'도산동',
			'신흥동',
			'어룡동',
			'우산동',
			'월곡1동',
			'월곡2동',
			'비아동',
			'첨단1동',
			'첨단2동',
			'신가동',
			'운남동',
			'수완동',
			'하남동',
			'임곡동',
			'동곡동',
			'평동',
			'삼도동',
			'본량동',
			'신창동',
		],
		남구: [
			'양림동',
			'방림1동',
			'방림2동',
			'봉선1동',
			'봉선2동',
			'사직동',
			'월산동',
			'월산4동',
			'월산5동',
			'백운1동',
			'백운2동',
			'주월1동',
			'주월2동',
			'진월동',
			'효덕동',
			'송암동',
			'대촌동',
		],
		동구: [
			'충장동',
			'동명동',
			'계림1동',
			'계림2동',
			'산수1동',
			'산수2동',
			'지산1동',
			'지산2동',
			'서남동',
			'학동',
			'학운동',
			'지원1동',
			'지원2동',
		],
		북구: [
			'중흥1동',
			'중흥동',
			'중앙동',
			'임동',
			'신안동',
			'용봉동',
			'운암1동',
			'운암2동',
			'운암3동',
			'동림동',
			'우산동',
			'풍향동',
			'문화동',
			'문흥1동',
			'문흥2동',
			'두암1동',
			'두암2동',
			'두암3동',
			'삼각동',
			'일곡동',
			'매곡동',
			'오치1동',
			'오치2동',
			'석곡동',
			'건국동',
			'양산동',
			'신용동',
		],
		서구: [
			'양동',
			'양3동',
			'농성1동',
			'농성2동',
			'광천동',
			'유덕동',
			'치평동',
			'상무1동',
			'상무2동',
			'화정1동',
			'화정2동',
			'화정3동',
			'화정4동',
			'서창동',
			'금호1동',
			'금호2동',
			'풍암동',
			'동천동',
		],
		기타: [],
	},
	대구광역시: {
		군위군: ['군위읍', '소보면', '효령면', '부계면', '우보면', '의흥면', '산성면', '삼국유사면'],
		남구: [
			'이천동',
			'봉덕1동',
			'봉덕2동',
			'봉덕3동',
			'대명1동',
			'대명2동',
			'대명3동',
			'대명4동',
			'대명5동',
			'대명6동',
			'대명9동',
			'대명10동',
			'대명11동',
		],
		달서구: [
			'성당동',
			'두류1.2동',
			'두류3동',
			'감삼동',
			'죽전동',
			'장기동',
			'용산1동',
			'용산2동',
			'이곡1동',
			'이곡2동',
			'신당동',
			'본리동',
			'월성1동',
			'월성2동',
			'진천동',
			'유천동',
			'상인1동',
			'상인2동',
			'상인3동',
			'도원동',
			'송현1동',
			'송현2동',
			'본동',
		],
		달성군: [
			'화원읍',
			'논공읍',
			'논공읍공단출장소',
			'다사읍',
			'다사읍서재출장소',
			'유가읍',
			'옥포읍',
			'현풍읍',
			'구지읍',
			'가창면',
			'하빈면',
		],
		동구: [
			'신암1동',
			'신암2동',
			'신암3동',
			'신암4동',
			'신암5동',
			'신천1.2동',
			'신천3동',
			'신천4동',
			'효목1동',
			'효목2동',
			'도평동',
			'불로.봉무동',
			'지저동',
			'동촌동',
			'방촌동',
			'해안동',
			'안심1동',
			'안심2동',
			'안심3동',
			'안심4동',
			'혁신동',
			'공산동',
		],
		북구: [
			'고성동',
			'칠성동',
			'침산1동',
			'침산2동',
			'침산3동',
			'산격1동',
			'산격2동',
			'산격3동',
			'산격4동',
			'대현동',
			'복현1동',
			'복현2동',
			'검단동',
			'무태조야동',
			'관문동',
			'태전1동',
			'태전2동',
			'구암동',
			'관음동',
			'읍내동',
			'동천동',
			'노원동',
			'국우동',
		],
		서구: [
			'내당1동',
			'내당2.3동',
			'내당4동',
			'비산1동',
			'비산2.3동',
			'비산4동',
			'비산5동',
			'비산6동',
			'비산7동',
			'평리1동',
			'평리2동',
			'평리3동',
			'평리4동',
			'평리5동',
			'평리6동',
			'상중이동',
			'원대동',
		],
		수성구: [
			'범어1동',
			'범어2동',
			'범어3동',
			'범어4동',
			'만촌1동',
			'만촌2동',
			'만촌3동',
			'수성1가동',
			'수성2.3가동',
			'수성4가동',
			'황금1동',
			'황금2동',
			'중동',
			'상동',
			'파동',
			'두산동',
			'지산1동',
			'지산2동',
			'범물1동',
			'범물2동',
			'고산1동',
			'고산2동',
			'고산3동',
		],
		중구: ['동인동', '삼덕동', '성내1동', '성내2동', '성내3동', '대신동', '남산1동', '남산2동', '남산3동', '남산4동', '대봉1동', '대봉2동'],
		기타: [],
	},
	대전광역시: {
		대덕구: ['오정동', '대화동', '회덕동', '비래동', '송촌동', '중리동', '신탄진동', '석봉동', '덕암동', '목상동', '법1동', '법2동'],
		동구: [
			'중앙동',
			'효동',
			'신인동',
			'판암1동',
			'판암2동',
			'용운동',
			'대동',
			'자양동',
			'가양1동',
			'가양2동',
			'용전동',
			'성남동',
			'홍도동',
			'삼성동',
			'대청동',
			'산내동',
		],
		서구: [
			'복수동',
			'도마1동',
			'도마2동',
			'정림동',
			'변동',
			'용문동',
			'탄방동',
			'괴정동',
			'가장동',
			'내동',
			'갈마1동',
			'갈마2동',
			'월평1동',
			'월평2동',
			'월평3동',
			'가수원동',
			'도안동',
			'관저1동',
			'관저2동',
			'기성동',
			'둔산1동',
			'둔산2동',
			'만년동',
			'둔산3동',
		],
		유성구: [
			'진잠동',
			'학하동',
			'상대동',
			'온천1동',
			'온천2동',
			'노은1동',
			'노은2동',
			'노은3동',
			'신성동',
			'전민동',
			'구즉동',
			'관평동',
			'원신흥동',
		],
		중구: [
			'은행선화동',
			'목동',
			'중촌동',
			'대흥동',
			'문창동',
			'석교동',
			'대사동',
			'부사동',
			'용두동',
			'오류동',
			'태평1동',
			'태평2동',
			'유천1동',
			'유천2동',
			'문화1동',
			'문화2동',
			'산성동',
		],
		기타: [],
	},
	부산광역시: {
		강서구: ['대저1동', '대저2동', '강동동', '명지1동', '명지2동', '가락동', '녹산동', '가덕도동', '신호동'],
		금정구: [
			'서제1동',
			'서제2동',
			'서제3동',
			'금사회동동',
			'부곡제1동',
			'부곡제2동',
			'부곡제3동',
			'부곡제4동',
			'장전제1동',
			'장전제2동',
			'선두구동',
			'청룡노포동',
			'남산동',
			'구서제1동',
			'구서제2동',
			'금성동',
		],
		기장군: ['기장읍', '장안읍', '정관읍', '일광읍', '철마면'],
		남구: [
			'대연제1동',
			'대연제3동',
			'대연제4동',
			'대연제5동',
			'대연제6동',
			'용호제1동',
			'용호제2동',
			'용호제3동',
			'용호제4동',
			'용당동',
			'감만제1동',
			'감만제2동',
			'우암동',
			'문현제1동',
			'문현제2동',
			'문현제3동',
			'문현제4동',
		],
		동구: [
			'초량제1동',
			'초량제2동',
			'초량제3동',
			'초량제6동',
			'수정제1동',
			'수정제2동',
			'수정제4동',
			'수정제5동',
			'좌천동',
			'범일제1동',
			'범일제2동',
			'범일제5동',
		],
		동래구: [
			'수민동',
			'복산동',
			'명륜동',
			'온천제1동',
			'온천제2동',
			'온천제3동',
			'사직제1동',
			'사직제2동',
			'사직제3동',
			'안락제1동',
			'안락제2동',
			'명장제1동',
			'명장제2동',
		],
		부산진구: [
			'부전제1동',
			'부전제2동',
			'연지동',
			'초읍동',
			'양정제1동',
			'양정제2동',
			'전포제1동',
			'전포제2동',
			'부암제1동',
			'부암제3동',
			'당감제1동',
			'당감제2동',
			'당감제4동',
			'가야제1동',
			'가야제2동',
			'개금제1동',
			'개금제2동',
			'개금제3동',
			'범천제1동',
			'범천제2동',
		],
		북구: [
			'구포제1동',
			'구포제2동',
			'구포제3동',
			'금곡동',
			'화명제1동',
			'화명제2동',
			'화명제3동',
			'덕천제1동',
			'덕천제2동',
			'덕천제3동',
			'만덕제1동',
			'만덕제2동',
			'만덕제3동',
		],
		사상구: [
			'삼락동',
			'모라제1동',
			'모라제3동',
			'덕포제1동',
			'덕포제2동',
			'괘법동',
			'감전동',
			'주례제1동',
			'주례제2동',
			'주례제3동',
			'학장동',
			'엄궁동',
		],
		사하구: [
			'괴정제1동',
			'괴정제2동',
			'괴정제3동',
			'괴정제4동',
			'당리동',
			'하단제1동',
			'하단제2동',
			'신평제1동',
			'신평제2동',
			'장림제1동',
			'장림제2동',
			'다대제1동',
			'다대제2동',
			'구평동',
			'감천제1동',
			'감천제2동',
		],
		서구: [
			'동대신제1동',
			'동대신제2동',
			'동대신제3동',
			'서대신제1동',
			'서대신제3동',
			'서대신제4동',
			'부민동',
			'아미동',
			'초장동',
			'충무동',
			'남부민제1동',
			'남부민제2동',
			'암남동',
		],
		수영구: ['남천제1동', '남천제2동', '수영동', '망미제1동', '망미제2동', '광안제1동', '광안제2동', '광안제3동', '광안제4동', '민락동'],
		연제구: [
			'거제제1동',
			'거제제2동',
			'거제제3동',
			'거제제4동',
			'연산제1동',
			'연산제2동',
			'연산제3동',
			'연산제4동',
			'연산제5동',
			'연산제6동',
			'연산제8동',
			'연산제9동',
		],
		영도구: [
			'남항동',
			'영선제1동',
			'영선제2동',
			'신선동',
			'봉래제1동',
			'봉래제2동',
			'청학제1동',
			'청학제2동',
			'동삼제1동',
			'동삼제2동',
			'동삼제3동',
		],
		중구: ['중앙동', '동광동', '대청동', '보수동', '부평동', '광복동', '남포동', '영주제1동', '영주제2동'],
		해운대구: [
			'우제1동',
			'우제2동',
			'우제3동',
			'중제1동',
			'중제2동',
			'좌제1동',
			'좌제2동',
			'좌제3동',
			'좌제4동',
			'송정동',
			'반여제1동',
			'반여제2동',
			'반여제3동',
			'반여제4동',
			'반송제1동',
			'반송제2동',
			'재송제1동',
			'재송제2동',
		],
		기타: [],
	},
	서울특별시: {
		강남구: [
			'신사동',
			'논현1동',
			'논현2동',
			'압구정동',
			'청담동',
			'삼성1동',
			'삼성2동',
			'대치1동',
			'대치2동',
			'대치4동',
			'역삼1동',
			'역삼2동',
			'도곡1동',
			'도곡2동',
			'개포1동',
			'개포2동',
			'개포3동',
			'개포4동',
			'세곡동',
			'일원본동',
			'일원1동',
			'수서동',
		],
		강동구: [
			'강일동',
			'상일제1동',
			'상일제2동',
			'명일제1동',
			'명일제2동',
			'고덕제1동',
			'고덕제2동',
			'암사제1동',
			'암사제2동',
			'암사제3동',
			'천호제1동',
			'천호제2동',
			'천호제3동',
			'성내제1동',
			'성내제2동',
			'성내제3동',
			'길동',
			'둔촌제1동',
			'둔촌제2동',
		],
		강북구: [
			'삼양동',
			'미아동',
			'송중동',
			'송천동',
			'삼각산동',
			'번1동',
			'번2동',
			'번3동',
			'수유1동',
			'수유2동',
			'수유3동',
			'우이동',
			'인수동',
		],
		강서구: [
			'염창동',
			'등촌제1동',
			'등촌제2동',
			'등촌제3동',
			'화곡제1동',
			'화곡제2동',
			'화곡제3동',
			'화곡제4동',
			'화곡본동',
			'화곡제6동',
			'화곡제8동',
			'가양제1동',
			'가양제2동',
			'가양제3동',
			'발산제1동',
			'우장산동',
			'공항동',
			'방화제1동',
			'방화제2동',
			'방화제3동',
		],
		관악구: [
			'보라매동',
			'청림동',
			'성현동',
			'행운동',
			'낙성대동',
			'청룡동',
			'은천동',
			'중앙동',
			'인헌동',
			'남현동',
			'서원동',
			'신원동',
			'서림동',
			'신사동',
			'신림동',
			'난향동',
			'조원동',
			'대학동',
			'삼성동',
			'미성동',
			'난곡동',
		],
		광진구: [
			'화양동',
			'군자동',
			'중곡제1동',
			'중곡제2동',
			'중곡제3동',
			'중곡제4동',
			'능동',
			'광장동',
			'자양제1동',
			'자양제2동',
			'자양제3동',
			'자양제4동',
			'구의제1동',
			'구의제2동',
			'구의제3동',
		],
		구로구: [
			'신도림동',
			'구로제1동',
			'구로제2동',
			'구로제3동',
			'구로제4동',
			'구로제5동',
			'가리봉동',
			'고척제1동',
			'고척제2동',
			'개봉제1동',
			'개봉제2동',
			'개봉제3동',
			'오류제1동',
			'오류제2동',
			'수궁동',
			'항동',
		],
		금천구: ['가산동', '독산제1동', '독산제2동', '독산제3동', '독산제4동', '시흥제1동', '시흥제2동', '시흥제3동', '시흥제4동', '시흥제5동'],
		노원구: [
			'월계1동',
			'월계2동',
			'월계3동',
			'공릉1동',
			'공릉2동',
			'하계1동',
			'하계2동',
			'중계본동',
			'중계1동',
			'중계4동',
			'중계2.3동',
			'상계1동',
			'상계2동',
			'상계3.4동',
			'상계5동',
			'상계6.7동',
			'상계8동',
			'상계9동',
			'상계10동',
		],
		도봉구: [
			'창제1동',
			'창제2동',
			'창제3동',
			'창제4동',
			'창제5동',
			'도봉제1동',
			'도봉제2동',
			'쌍문제1동',
			'쌍문제2동',
			'쌍문제3동',
			'쌍문제4동',
			'방학제1동',
			'방학제2동',
			'방학제3동',
		],
		동대문구: [
			'신설동',
			'용두동',
			'제기동',
			'전농제1동',
			'전농제2동',
			'답십리제1동',
			'답십리제2동',
			'장안제1동',
			'장안제2동',
			'청량리동',
			'회기동',
			'휘경제1동',
			'휘경제2동',
			'이문제1동',
			'이문제2동',
		],
		동작구: [
			'노량진제1동',
			'노량진제2동',
			'상도제1동',
			'상도제2동',
			'상도제3동',
			'상도제4동',
			'흑석동',
			'사당제1동',
			'사당제2동',
			'사당제3동',
			'사당제4동',
			'사당제5동',
			'대방동',
			'신대방제1동',
			'신대방제2동',
		],
		마포구: [
			'아현동',
			'공덕동',
			'도화동',
			'용강동',
			'대흥동',
			'염리동',
			'신수동',
			'서강동',
			'서교동',
			'합정동',
			'망원제1동',
			'망원제2동',
			'연남동',
			'성산제1동',
			'성산제2동',
			'상암동',
		],
		서대문구: [
			'천연동',
			'북아현동',
			'충현동',
			'신촌동',
			'연희동',
			'홍제제1동',
			'홍제제3동',
			'홍제제2동',
			'홍은제1동',
			'홍은제2동',
			'남가좌제1동',
			'남가좌제2동',
			'북가좌제1동',
			'북가좌제2동',
		],
		서초구: [
			'서초1동',
			'서초2동',
			'서초3동',
			'서초4동',
			'잠원동',
			'반포본동',
			'반포1동',
			'반포2동',
			'반포3동',
			'반포4동',
			'방배본동',
			'방배1동',
			'방배2동',
			'방배3동',
			'방배4동',
			'양재1동',
			'양재2동',
			'내곡동',
		],
		성동구: [
			'왕십리제2동',
			'왕십리도선동',
			'마장동',
			'사근동',
			'행당제1동',
			'행당제2동',
			'응봉동',
			'금호1가동',
			'금호2.3가동',
			'금호4가동',
			'옥수동',
			'성수1가제1동',
			'성수1가제2동',
			'성수2가제1동',
			'성수2가제3동',
			'송정동',
			'용답동',
		],
		성북구: [
			'성북동',
			'삼선동',
			'동선동',
			'돈암제1동',
			'돈암제2동',
			'안암동',
			'보문동',
			'정릉제1동',
			'정릉제2동',
			'정릉제3동',
			'정릉제4동',
			'길음제1동',
			'길음제2동',
			'종암동',
			'월곡제1동',
			'월곡제2동',
			'장위제1동',
			'장위제2동',
			'장위제3동',
			'석관동',
		],
		송파구: [
			'풍납1동',
			'풍납2동',
			'거여1동',
			'거여2동',
			'마천1동',
			'마천2동',
			'방이1동',
			'방이2동',
			'오륜동',
			'오금동',
			'송파1동',
			'송파2동',
			'석촌동',
			'삼전동',
			'가락본동',
			'가락1동',
			'가락2동',
			'문정1동',
			'문정2동',
			'장지동',
			'위례동',
			'잠실본동',
			'잠실2동',
			'잠실3동',
			'잠실4동',
			'잠실6동',
			'잠실7동',
		],
		양천구: [
			'목1동',
			'목2동',
			'목3동',
			'목4동',
			'목5동',
			'신월1동',
			'신월2동',
			'신월3동',
			'신월4동',
			'신월5동',
			'신월6동',
			'신월7동',
			'신정1동',
			'신정2동',
			'신정3동',
			'신정4동',
			'신정6동',
			'신정7동',
		],
		영등포구: [
			'영등포본동',
			'영등포동',
			'여의동',
			'당산제1동',
			'당산제2동',
			'도림동',
			'문래동',
			'양평제1동',
			'양평제2동',
			'신길제1동',
			'신길제3동',
			'신길제4동',
			'신길제5동',
			'신길제6동',
			'신길제7동',
			'대림제1동',
			'대림제2동',
			'대림제3동',
		],
		용산구: [
			'후암동',
			'용산2가동',
			'남영동',
			'청파동',
			'원효로제1동',
			'원효로제2동',
			'효창동',
			'용문동',
			'한강로동',
			'이촌제1동',
			'이촌제2동',
			'이태원제1동',
			'이태원제2동',
			'한남동',
			'서빙고동',
			'보광동',
		],
		은평구: [
			'녹번동',
			'불광제1동',
			'불광제2동',
			'갈현제1동',
			'갈현제2동',
			'구산동',
			'대조동',
			'응암제1동',
			'응암제2동',
			'응암제3동',
			'역촌동',
			'신사제1동',
			'신사제2동',
			'증산동',
			'수색동',
			'진관동',
		],
		종로구: [
			'청운효자동',
			'사직동',
			'삼청동',
			'부암동',
			'평창동',
			'무악동',
			'교남동',
			'가회동',
			'종로1.2.3.4가동',
			'종로5.6가동',
			'이화동',
			'혜화동',
			'창신제1동',
			'창신제2동',
			'창신제3동',
			'숭인제1동',
			'숭인제2동',
		],
		중구: [
			'소공동',
			'회현동',
			'명동',
			'필동',
			'장충동',
			'광희동',
			'을지로동',
			'신당동',
			'다산동',
			'약수동',
			'청구동',
			'신당제5동',
			'동화동',
			'황학동',
			'중림동',
		],
		중랑구: [
			'면목제2동',
			'면목제4동',
			'면목제5동',
			'면목본동',
			'면목제7동',
			'면목제3.8동',
			'상봉제1동',
			'상봉제2동',
			'중화제1동',
			'중화제2동',
			'묵제1동',
			'묵제2동',
			'망우본동',
			'망우제3동',
			'신내1동',
			'신내2동',
		],
		기타: [],
	},
	울산광역시: {
		남구: [
			'신정1동',
			'신정2동',
			'신정3동',
			'신정4동',
			'신정5동',
			'달동',
			'삼산동',
			'삼호동',
			'무거동',
			'옥동',
			'대현동',
			'수암동',
			'선암동',
			'야음장생포동',
		],
		동구: ['방어동', '일산동', '화정동', '대송동', '전하1동', '전하2동', '남목1동', '남목2동', '남목3동'],
		북구: ['농소1동', '농소2동', '농소3동', '강동동', '효문동', '송정동', '양정동', '염포동'],
		울주군: ['온산읍', '언양읍', '온양읍', '범서읍', '청량읍', '삼남읍', '서생면', '웅촌면', '두동면', '두서면', '상북면', '삼동면'],
		중구: ['학성동', '반구1동', '반구2동', '복산동', '중앙동', '우정동', '태화동', '다운동', '병영1동', '병영2동', '약사동', '성안동'],
		기타: [],
	},
	인천광역시: {
		강화군: [
			'강화읍',
			'선원면',
			'불은면',
			'길상면',
			'화도면',
			'양도면',
			'내가면',
			'하점면',
			'양사면',
			'송해면',
			'교동면',
			'삼산면',
			'서도면',
			'서도면볼음출장소',
		],
		검단구: ['검단동', '불로대곡동', '원당동', '당하동', '오류왕길동', '마전동', '아라1동', '아라2동'],
		계양구: [
			'효성1동',
			'효성2동',
			'계산1동',
			'계산2동',
			'계산3동',
			'계산4동',
			'작전1동',
			'작전2동',
			'작전서운동',
			'계양1동',
			'계양2동',
			'계양3동',
		],
		남동구: [
			'구월1동',
			'구월2동',
			'구월3동',
			'구월4동',
			'간석1동',
			'간석2동',
			'간석3동',
			'간석4동',
			'만수1동',
			'만수2동',
			'만수3동',
			'만수4동',
			'만수5동',
			'만수6동',
			'장수서창동',
			'서창2동',
			'남촌도림동',
			'논현1동',
			'논현2동',
			'논현고잔동',
		],
		미추홀구: [
			'숭의2동',
			'숭의1.3동',
			'숭의4동',
			'용현1.4동',
			'용현2동',
			'용현3동',
			'용현5동',
			'학익1동',
			'학익2동',
			'도화1동',
			'도화2.3동',
			'주안1동',
			'주안2동',
			'주안3동',
			'주안4동',
			'주안5동',
			'주안6동',
			'주안7동',
			'주안8동',
			'관교동',
			'문학동',
		],
		부평구: [
			'부평1동',
			'부평2동',
			'부평3동',
			'부평4동',
			'부평5동',
			'부평6동',
			'산곡1동',
			'산곡2동',
			'산곡3동',
			'산곡4동',
			'청천1동',
			'청천2동',
			'갈산1동',
			'갈산2동',
			'삼산1동',
			'삼산2동',
			'부개1동',
			'부개2동',
			'부개3동',
			'일신동',
			'십정1동',
			'십정2동',
		],
		서해구: [
			'검암경서동',
			'연희동',
			'청라1동',
			'청라2동',
			'청라3동',
			'가정1동',
			'가정2동',
			'가정3동',
			'석남1동',
			'석남2동',
			'석남3동',
			'신현원창동',
			'가좌1동',
			'가좌2동',
			'가좌3동',
			'가좌4동',
		],
		연수구: [
			'옥련1동',
			'옥련2동',
			'선학동',
			'연수1동',
			'연수2동',
			'연수3동',
			'청학동',
			'동춘1동',
			'동춘2동',
			'동춘3동',
			'송도1동',
			'송도2동',
			'송도3동',
			'송도4동',
			'송도5동',
		],
		영종구: ['영종동', '영종1동', '영종2동', '운서1동', '운서2동', '용유동'],
		옹진군: [
			'북도면',
			'북도면장봉출장소',
			'백령면',
			'대청면',
			'대청면소청출장소',
			'덕적면',
			'영흥면',
			'자월면',
			'자월면이작출장소',
			'연평면',
		],
		제물포구: [
			'신포동',
			'연안동',
			'신흥동',
			'도원동',
			'율목동',
			'동인천동',
			'개항동',
			'만석동',
			'화수1.화평동',
			'화수2동',
			'송현1.2동',
			'송현3동',
			'송림1동',
			'송림2동',
			'송림3·5동',
			'송림4동',
			'송림6동',
			'금창동',
		],
		기타: [],
	},
	전라남도: {
		강진군: ['강진읍', '군동면', '칠량면', '대구면', '도암면', '신전면', '성전면', '작천면', '병영면', '옴천면', '마량면'],
		고흥군: [
			'고흥읍',
			'도양읍',
			'도양읍소록출장소',
			'도양읍시산출장소',
			'풍양면',
			'도덕면',
			'금산면',
			'도화면',
			'포두면',
			'봉래면',
			'점암면',
			'과역면',
			'남양면',
			'동강면',
			'대서면',
			'두원면',
			'영남면',
			'동일면',
		],
		곡성군: ['곡성읍', '오곡면', '삼기면', '석곡면', '목사동면', '죽곡면', '고달면', '옥과면', '입면', '겸면', '오산면'],
		광양시: ['광양읍', '봉강면', '옥룡면', '옥곡면', '진상면', '진월면', '다압면', '골약동', '중마동', '광영동', '금호동', '태인동'],
		구례군: ['구례읍', '문척면', '간전면', '토지면', '마산면', '광의면', '용방면', '산동면'],
		나주시: [
			'남평읍',
			'세지면',
			'왕곡면',
			'반남면',
			'공산면',
			'동강면',
			'다시면',
			'문평면',
			'노안면',
			'금천면',
			'산포면',
			'다도면',
			'봉황면',
			'송월동',
			'영강동',
			'금남동',
			'성북동',
			'영산동',
			'이창동',
			'빛가람동',
		],
		담양군: ['담양읍', '봉산면', '고서면', '가사문학면', '창평면', '대덕면', '무정면', '금성면', '용면', '월산면', '수북면', '대전면'],
		목포시: [
			'용당1동',
			'용당2동',
			'연동',
			'산정동',
			'연산동',
			'원산동',
			'대성동',
			'목원동',
			'동명동',
			'삼학동',
			'만호동',
			'유달동',
			'죽교동',
			'북항동',
			'용해동',
			'이로동',
			'상동',
			'하당동',
			'신흥동',
			'삼향동',
			'옥암동',
			'부흥동',
			'부주동',
		],
		무안군: ['무안읍', '일로읍', '삼향읍', '삼향읍남악출장소', '몽탄면', '청계면', '현경면', '망운면', '해제면', '운남면'],
		보성군: [
			'보성읍',
			'벌교읍',
			'노동면',
			'미력면',
			'겸백면',
			'율어면',
			'복내면',
			'문덕면',
			'조성면',
			'득량면',
			'득량면예당출장소',
			'회천면',
			'웅치면',
		],
		순천시: [
			'승주읍',
			'해룡면',
			'해룡면상삼출장소',
			'해룡면신대출장소',
			'서면',
			'황전면',
			'월등면',
			'주암면',
			'송광면',
			'외서면',
			'낙안면',
			'별량면',
			'상사면',
			'향동',
			'매곡동',
			'삼산동',
			'조곡동',
			'덕연동',
			'풍덕동',
			'남제동',
			'저전동',
			'장천동',
			'중앙동',
			'도사동',
			'왕조1동',
			'왕조2동',
		],
		신안군: [
			'지도읍',
			'지도읍선도출장소',
			'압해읍',
			'압해읍매화출장소',
			'압해읍고이도출장소',
			'증도면',
			'증도면병풍출장소',
			'임자면',
			'자은면',
			'비금면',
			'비금면수치도출장소',
			'도초면',
			'도초면우이도출장소',
			'흑산면',
			'흑산면가거도출장소',
			'흑산면태도출장소',
			'흑산면홍도출장소',
			'흑산면대둔도출장소',
			'하의면',
			'신의면',
			'장산면',
			'안좌면',
			'팔금면',
			'암태면',
		],
		여수시: [
			'돌산읍',
			'돌산읍우두출장소',
			'돌산읍죽포출장소',
			'소라면',
			'율촌면',
			'화양면',
			'남면',
			'화정면',
			'화정면개도출장소',
			'삼산면',
			'동문동',
			'한려동',
			'중앙동',
			'충무동',
			'광림동',
			'서강동',
			'대교동',
			'국동',
			'월호동',
			'여서동',
			'문수동',
			'미평동',
			'둔덕동',
			'만덕동',
			'쌍봉동',
			'시전동',
			'여천동',
			'주삼동',
			'삼일동',
			'묘도동',
		],
		영광군: [
			'영광읍',
			'백수읍',
			'홍농읍',
			'대마면',
			'묘량면',
			'불갑면',
			'군서면',
			'군남면',
			'염산면',
			'법성면',
			'낙월면',
			'낙월면안마출장소',
		],
		영암군: [
			'영암읍',
			'삼호읍',
			'삼호읍서부출장소',
			'덕진면',
			'금정면',
			'신북면',
			'시종면',
			'도포면',
			'군서면',
			'서호면',
			'학산면',
			'미암면',
		],
		완도군: [
			'완도읍',
			'금일읍',
			'노화읍',
			'노화읍넙도출장소',
			'군외면',
			'신지면',
			'고금면',
			'약산면',
			'청산면',
			'청산면모도출장소',
			'소안면',
			'금당면',
			'보길면',
			'생일면',
		],
		장성군: ['장성읍', '진원면', '남면', '동화면', '삼서면', '삼계면', '황룡면', '서삼면', '북일면', '북이면', '북하면'],
		장흥군: ['장흥읍', '관산읍', '대덕읍', '용산면', '안양면', '장동면', '장평면', '유치면', '부산면', '회진면'],
		진도군: ['진도읍', '군내면', '고군면', '의신면', '임회면', '지산면', '조도면', '조도면가사출장소', '조도면거차출장소'],
		함평군: ['함평읍', '손불면', '신광면', '학교면', '엄다면', '대동면', '나산면', '해보면', '월야면'],
		해남군: [
			'해남읍',
			'삼산면',
			'화산면',
			'현산면',
			'송지면',
			'북평면',
			'북일면',
			'옥천면',
			'계곡면',
			'마산면',
			'황산면',
			'산이면',
			'문내면',
			'화원면',
		],
		화순군: [
			'화순읍',
			'화순읍민원출장소',
			'한천면',
			'한천면영외출장소',
			'춘양면',
			'청풍면',
			'이양면',
			'능주면',
			'도곡면',
			'도암면',
			'이서면',
			'백아면',
			'동복면',
			'사평면',
			'동면',
		],
		기타: [],
	},
	전북특별자치도: {
		고창군: [
			'고창읍',
			'고수면',
			'아산면',
			'무장면',
			'공음면',
			'상하면',
			'해리면',
			'성송면',
			'대산면',
			'심원면',
			'흥덕면',
			'성내면',
			'신림면',
			'부안면',
		],
		군산시: [
			'옥구읍',
			'옥산면',
			'회현면',
			'임피면',
			'서수면',
			'대야면',
			'개정면',
			'성산면',
			'나포면',
			'옥도면',
			'옥서면',
			'해신동',
			'월명동',
			'신풍동',
			'삼학동',
			'중앙동',
			'흥남동',
			'조촌동',
			'경암동',
			'구암동',
			'개정동',
			'수송동',
			'나운1동',
			'나운2동',
			'나운3동',
			'소룡동',
			'미성동',
		],
		김제시: [
			'만경읍',
			'죽산면',
			'백산면',
			'용지면',
			'백구면',
			'부량면',
			'공덕면',
			'청하면',
			'성덕면',
			'진봉면',
			'금구면',
			'봉남면',
			'황산면',
			'금산면',
			'광활면',
			'요촌동',
			'신풍동',
			'검산동',
			'교월동',
		],
		남원시: [
			'운봉읍',
			'주천면',
			'수지면',
			'송동면',
			'주생면',
			'금지면',
			'대강면',
			'대산면',
			'사매면',
			'덕과면',
			'보절면',
			'산동면',
			'이백면',
			'아영면',
			'산내면',
			'인월면',
			'동충동',
			'죽항동',
			'노암동',
			'금동',
			'왕정동',
			'향교동',
			'도통동',
		],
		무주군: ['무주읍', '무풍면', '설천면', '적상면', '안성면', '부남면'],
		부안군: [
			'부안읍',
			'주산면',
			'동진면',
			'행안면',
			'계화면',
			'보안면',
			'변산면',
			'진서면',
			'백산면',
			'상서면',
			'하서면',
			'줄포면',
			'위도면',
		],
		순창군: ['순창읍', '인계면', '동계면', '풍산면', '금과면', '팔덕면', '쌍치면', '복흥면', '적성면', '유등면', '구림면'],
		완주군: [
			'삼례읍',
			'봉동읍',
			'용진읍',
			'상관면',
			'이서면',
			'소양면',
			'구이면',
			'고산면',
			'비봉면',
			'운주면',
			'화산면',
			'동상면',
			'경천면',
		],
		익산시: [
			'함열읍',
			'오산면',
			'황등면',
			'함라면',
			'웅포면',
			'성당면',
			'용안면',
			'낭산면',
			'망성면',
			'여산면',
			'금마면',
			'왕궁면',
			'춘포면',
			'삼기면',
			'용동면',
			'중앙동',
			'평화동',
			'인화동',
			'동산동',
			'마동',
			'남중동',
			'모현동',
			'송학동',
			'영등1동',
			'영등2동',
			'어양동',
			'신동',
			'팔봉동',
			'삼성동',
		],
		임실군: ['임실읍', '청웅면', '운암면', '신평면', '성수면', '오수면', '신덕면', '삼계면', '관촌면', '강진면', '덕치면', '지사면'],
		장수군: ['장수읍', '산서면', '번암면', '장계면', '천천면', '계남면', '계북면'],
		'전주시 덕진구': [
			'진북동',
			'인후1동',
			'인후2동',
			'인후3동',
			'덕진동',
			'금암동',
			'팔복동',
			'우아1동',
			'우아2동',
			'호성동',
			'송천1동',
			'송천2동',
			'송천3동',
			'조촌동',
			'여의동',
			'혁신동',
		],
		'전주시 완산구': [
			'중앙동',
			'풍남동',
			'노송동',
			'완산동',
			'동서학동',
			'서서학동',
			'중화산1동',
			'중화산2동',
			'서신동',
			'평화1동',
			'평화2동',
			'삼천1동',
			'삼천2동',
			'삼천3동',
			'효자1동',
			'효자2동',
			'효자3동',
			'효자4동',
			'효자5동',
		],
		정읍시: [
			'신태인읍',
			'북면',
			'입암면',
			'소성면',
			'고부면',
			'영원면',
			'덕천면',
			'이평면',
			'정우면',
			'태인면',
			'감곡면',
			'옹동면',
			'칠보면',
			'산내면',
			'산외면',
			'수성동',
			'장명동',
			'내장상동',
			'시기동',
			'초산동',
			'연지동',
			'농소동',
			'상교동',
		],
		진안군: ['진안읍', '용담면', '안천면', '동향면', '상전면', '백운면', '성수면', '마령면', '부귀면', '정천면', '주천면'],
		기타: [],
	},
	제주특별자치도: {
		서귀포시: [
			'대정읍',
			'남원읍',
			'성산읍',
			'안덕면',
			'표선면',
			'송산동',
			'정방동',
			'중앙동',
			'천지동',
			'효돈동',
			'영천동',
			'동홍동',
			'서홍동',
			'대륜동',
			'대천동',
			'중문동',
			'예래동',
		],
		제주시: [
			'한림읍',
			'애월읍',
			'구좌읍',
			'조천읍',
			'한경면',
			'추자면',
			'우도면',
			'일도1동',
			'일도2동',
			'이도1동',
			'이도2동',
			'삼도1동',
			'삼도2동',
			'용담1동',
			'용담2동',
			'건입동',
			'화북동',
			'삼양동',
			'봉개동',
			'아라동',
			'오라동',
			'연동',
			'노형동',
			'외도동',
			'이호동',
			'도두동',
		],
		기타: [],
	},
	충청남도: {
		계룡시: ['두마면', '엄사면', '신도안면', '금암동'],
		공주시: [
			'유구읍',
			'이인면',
			'탄천면',
			'계룡면',
			'반포면',
			'의당면',
			'정안면',
			'우성면',
			'사곡면',
			'신풍면',
			'중학동',
			'웅진동',
			'금학동',
			'옥룡동',
			'신관동',
			'월송동',
		],
		금산군: ['금산읍', '금성면', '제원면', '부리면', '군북면', '남일면', '남이면', '진산면', '복수면', '추부면'],
		논산시: [
			'강경읍',
			'연무읍',
			'성동면',
			'광석면',
			'노성면',
			'상월면',
			'부적면',
			'연산면',
			'벌곡면',
			'양촌면',
			'가야곡면',
			'은진면',
			'채운면',
			'취암동',
			'부창동',
		],
		당진시: [
			'합덕읍',
			'송악읍',
			'고대면',
			'석문면',
			'대호지면',
			'정미면',
			'면천면',
			'순성면',
			'우강면',
			'신평면',
			'송산면',
			'당진1동',
			'당진2동',
			'당진3동',
		],
		보령시: [
			'웅천읍',
			'주포면',
			'오천면',
			'오천면어항출장소',
			'원산출장소',
			'천북면',
			'청소면',
			'청라면',
			'남포면',
			'주산면',
			'미산면',
			'성주면',
			'주교면',
			'대천1동',
			'대천2동',
			'대천3동',
			'대천4동',
			'대천5동',
		],
		부여군: [
			'부여읍',
			'규암면',
			'은산면',
			'외산면',
			'내산면',
			'구룡면',
			'홍산면',
			'옥산면',
			'남면',
			'충화면',
			'양화면',
			'임천면',
			'장암면',
			'세도면',
			'석성면',
			'초촌면',
		],
		서산시: [
			'대산읍',
			'인지면',
			'부석면',
			'팔봉면',
			'지곡면',
			'성연면',
			'음암면',
			'운산면',
			'해미면',
			'고북면',
			'부춘동',
			'동문1동',
			'동문2동',
			'수석동',
			'석남동',
		],
		서천군: [
			'장항읍',
			'서천읍',
			'마서면',
			'화양면',
			'기산면',
			'한산면',
			'마산면',
			'시초면',
			'문산면',
			'판교면',
			'종천면',
			'비인면',
			'서면',
		],
		아산시: [
			'염치읍',
			'배방읍',
			'송악면',
			'탕정면',
			'음봉면',
			'둔포면',
			'영인면',
			'인주면',
			'선장면',
			'도고면',
			'신창면',
			'온양1동',
			'온양2동',
			'온양3동',
			'온양4동',
			'온양5동',
			'온양6동',
		],
		예산군: ['예산읍', '삽교읍', '대술면', '신양면', '광시면', '대흥면', '응봉면', '덕산면', '봉산면', '고덕면', '신암면', '오가면'],
		'천안시 동남구': [
			'목천읍',
			'풍세면',
			'광덕면',
			'북면',
			'성남면',
			'수신면',
			'병천면',
			'동면',
			'중앙동',
			'문성동',
			'원성1동',
			'원성2동',
			'봉명동',
			'일봉동',
			'신방동',
			'청룡동',
			'신안동',
		],
		'천안시 서북구': [
			'성환읍',
			'성거읍',
			'직산읍',
			'입장면',
			'성정1동',
			'성정2동',
			'쌍용1동',
			'쌍용2동',
			'쌍용3동',
			'백석동',
			'불당1동',
			'불당2동',
			'부성1동',
			'부성2동',
		],
		청양군: ['청양읍', '운곡면', '대치면', '정산면', '목면', '청남면', '장평면', '남양면', '화성면', '비봉면'],
		태안군: ['태안읍', '안면읍', '고남면', '남면', '근흥면', '소원면', '원북면', '이원면'],
		홍성군: ['홍성읍', '광천읍', '홍북읍', '금마면', '홍동면', '장곡면', '은하면', '결성면', '서부면', '갈산면', '구항면'],
		기타: [],
	},
	충청북도: {
		괴산군: ['괴산읍', '감물면', '장연면', '연풍면', '칠성면', '문광면', '청천면', '청안면', '사리면', '소수면', '불정면'],
		단양군: ['단양읍', '매포읍', '대강면', '가곡면', '영춘면', '어상천면', '적성면', '단성면'],
		보은군: ['보은읍', '속리산면', '장안면', '마로면', '탄부면', '삼승면', '수한면', '회남면', '회인면', '내북면', '산외면'],
		세종특별자치시: [
			'조치원읍',
			'연기면',
			'연동면',
			'부강면',
			'금남면',
			'장군면',
			'연서면',
			'전의면',
			'전동면',
			'소정면',
			'한솔동',
			'새롬동',
			'나성동',
			'도담동',
			'어진동',
			'해밀동',
			'아름동',
			'종촌동',
			'고운동',
			'소담동',
			'반곡동',
			'집현동',
			'보람동',
			'대평동',
			'다정동',
		],
		영동군: ['영동읍', '용산면', '황간면', '추풍령면', '매곡면', '상촌면', '양강면', '용화면', '학산면', '양산면', '심천면'],
		옥천군: ['옥천읍', '동이면', '안남면', '안내면', '청성면', '청산면', '이원면', '군서면', '군북면'],
		음성군: [
			'음성읍',
			'금왕읍',
			'대소읍',
			'대소읍성본산업단지출장소',
			'소이면',
			'원남면',
			'맹동면',
			'맹동면혁신도시출장소',
			'삼성면',
			'생극면',
			'감곡면',
		],
		제천시: [
			'봉양읍',
			'금성면',
			'청풍면',
			'수산면',
			'덕산면',
			'한수면',
			'백운면',
			'송학면',
			'교동',
			'의림지동',
			'중앙동',
			'남현동',
			'영서동',
			'용두동',
			'신백동',
			'청전동',
			'화산동',
		],
		증평군: ['증평읍', '도안면'],
		진천군: ['진천읍', '덕산읍', '덕산읍혁신도시출장소', '초평면', '문백면', '백곡면', '이월면', '광혜원면'],
		'청주시 상당구': [
			'낭성면',
			'미원면',
			'가덕면',
			'남일면',
			'문의면',
			'중앙동',
			'성안동',
			'탑대성동',
			'영운동',
			'금천동',
			'용담.명암.산성동',
			'용암1동',
			'용암2동',
		],
		'청주시 서원구': [
			'남이면',
			'현도면',
			'사직1동',
			'사직2동',
			'사창동',
			'모충동',
			'산남동',
			'분평동',
			'수곡1동',
			'수곡2동',
			'성화.개신.죽림동',
		],
		'청주시 청원구': ['내수읍', '오창읍', '북이면', '우암동', '내덕1동', '내덕2동', '율량.사천동', '오근장동'],
		'청주시 흥덕구': [
			'오송읍',
			'강내면',
			'옥산면',
			'운천.신봉동',
			'복대1동',
			'복대2동',
			'가경동',
			'봉명1동',
			'봉명2.송정동',
			'강서제1동',
			'강서제2동',
		],
		충주시: [
			'주덕읍',
			'살미면',
			'수안보면',
			'대소원면',
			'신니면',
			'노은면',
			'앙성면',
			'중앙탑면',
			'금가면',
			'동량면',
			'산척면',
			'엄정면',
			'소태면',
			'성내.충인동',
			'교현.안림동',
			'교현2동',
			'용산동',
			'지현동',
			'문화동',
			'호암.직동',
			'달천동',
			'봉방동',
			'칠금.금릉동',
			'연수동',
			'목행.용탄동',
		],
		기타: [],
	},
	기타: {},
}
